/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Modalita\' di scadenza dei voucher del bando
 */
export enum ScadenzaVoucherModalita {

    DATA_FISSA = 'DATA_FISSA',

    RELATIVA = 'RELATIVA'
}

